import { EmailSendRequest } from "./email/email";
import { defaultEmptyMimshakData, MimshakData } from "./mimshakData";

export enum SimulationStatus {
    DRAFT = "DRAFT",
    FINALIZED = "FINALIZED",
    SELECTED = "SELECTED",
    APPROVED = "APPROVED",
    DISCARDED = "DISCARDED"
  }

  export enum SimulationChangeType {
    UNCHANGED = "UNCHANGED",
    CHANGE_FUND = "CHANGE_FUND",
    CHANGE_FEE = "CHANGE_FEE",
    CLOSE_AND_MOVE = "CLOSE_AND_MOVE",
    PARTIAL_TRANSFER = "PARTIAL_TRANSFER",
    OPEN_NEW = "OPEN_NEW",
    DEPOSIT = "DEPOSIT",
    WITHDRAWAL = "WITHDRAWAL",
    NEW_RECURRENT_DEPOSIT = "NEW_RECURRENT_DEPOSIT",
    CHANGE_RECURRENT_DEPOSIT = "CHANGE_RECURRENT_DEPOSIT",
    STOP_RECURRENT_DEPOSIT = "STOP_RECURRENT_DEPOSIT",
    INSURANCE_HANDLER_CHANGE = "INSURANCE_HANDLER_CHANGE",
    INSURANCE_COVERAGE_INCREASE = "INSURANCE_COVERAGE_INCREASE",
    BENEFICIARY_UPDATE = "BENEFICIARY_UPDATE",
    VIEW_POWER_OF_ATTORNEY = "VIEW_POWER_OF_ATTORNEY", // ייפוי כוח לצפייה
  }

  export type FundAdditionType = 'deposit' | 'recurrent' | 'transfer' | 'withdrawal';

  export interface PolicyFundAdditions {
    deposit?: number;
    recurrent?: number | null; // null = stop recurrent deposit
    transfer?: number;
    transferSourcePolicy?: string; // לעתיד - עבור ניוד
    withdrawal?: number;
  }

  export type FundSumDropMap = Record<string, PolicyFundAdditions>;

  export interface FundSumChip {
    amount: number;
    type: FundAdditionType;
    contactId?: number;
    productType?: number;
  }

  export interface SimulationData {
    exposure_map?: Record<string, any>;
  }

  export interface Simulation {
    id: number;
    contact_id?: number;        // ⬅ אופציונלי: סימולציה אישית
    family_id?: number;      // ⬅ אופציונלי: סימולציה משפחתית
    reported_period: string;
    status: SimulationStatus;
    created_at: string;
    updated_at?: string;
    name?: string;
    notes?: string;
    selected: boolean;
    changed_policies_count: number;
    is_pre_advice: boolean;
    data?: SimulationData;
  }

  export interface SimulationMimshakData extends MimshakData {
    simulation_id?: number;
    virtual_policy_id?: string;
    change_types?: SimulationChangeType[];
    is_pre_advice?: boolean;
    note?: string; // הערה לסימולציה
  }
  export const defaultEmptySimulationData = (
    simulationId: number,
    contactId: number
  ): Omit<SimulationMimshakData, 'id'> => ({
    ...defaultEmptyMimshakData(contactId),
    simulation_id: simulationId,
    virtual_policy_id: undefined,
    change_types:[],
    is_pre_advice: undefined,
  });

  export interface CreateSimulationRequest {
    contact_id?: number;           // סימולציה אישית או
    family_id?: number;         // סימולציה משפחתית
    reported_period: string;    // פורמט YYYY-MM-DD
    name?: string;
    notes?: string;
    status?: SimulationStatus;  // ברירת מחדל: DRAFT
    is_pre_advice?: boolean;    // האם זה טרום ייעוץ
    data?: SimulationData;
  }


export type SimulationSource = "gemelLab" | "pensionLab" | "insuranceLab" | "quickTaskAction";

export interface CreateQuickSimulationRequest {
  simulation?: CreateSimulationRequest;
  items: SimulationMimshakData[];
  create_tasks: boolean;
  send_email?: EmailSendRequest;
  source?: SimulationSource;
  selected_step_codes?: string[];
}

export interface CreateQuickSimulationResponse {
  simulation?: Simulation;
  tasks_created: number;
  /** the tasks made - to continue with them (e.g. a form prepared for a fund) */
  created_tasks?: { id: number; policy_number?: string | null; handler_code?: string | null; task_type?: string | null }[];
}
